import React from "react";
import InputNumber from "antd/lib/input-number";
import { useTheme } from "@/components/ThemeProvider";

export default function NumberField({ form, field, ...otherProps }) {
  const { isDarkMode } = useTheme();
  return <InputNumber {...otherProps} className={isDarkMode ? "dark-mode" : ""} />;
}
